import React from 'react'

const AnalyticCardSkeleton: React.FC = () => {
    return (
        <div className="bg-white rounded-[8px] p-4 col-span-1 animate-pulse">
            <div className="flex justify-between items-center">
                <div className="space-y-2">
                    <div className="h-6 w-24 bg-gray-200 rounded" />
                    <div className="h-4 w-32 bg-gray-200 rounded" />
                </div>
                <div className="w-8 h-8 bg-gray-200 rounded" />
            </div>
            <div className="bg-gray-50 mt-4 px-2 py-4 rounded-sm flex gap-2 flex-wrap">
                <div className="h-4 w-20 bg-gray-200 rounded" />
                <div className="h-4 w-16 bg-gray-300 rounded" />
                <div className="h-4 w-20 bg-gray-200 rounded" />
                <div className="h-4 w-16 bg-gray-300 rounded" />
            </div>
        </div>
    )
}

export default AnalyticCardSkeleton
